import {
    ADD_FEATURE_TO_LAND_ASSEMBLY,
    REMOVE_FEATURE_FROM_LAND_ASSEMBLY,
    TOGGLE_LAND_ASSEMBLY_FEATURES,
    SET_LAND_ASSEMBLY_FEATURES,
    FETCH_STATS_REQUEST,
    FETCH_STATS_SUCCESS,
    FETCH_STATS_FAILURE,
    SET_SITE_CARD_CREATOR_OPEN,
    SET_LAND_ASSEMBLY_LAYER
} from './Types';

import { ILandAssemblyAction, ILandAssemblyReducerState } from './landAssemblyTypes';

const defaultState = {
    layerId: null,
    features: [],
    // featureIds: [],
    isFetchingStats: false,
    stats: null,
    error: null,

    isCreatingSiteCard: false
};

export default function reducer(
    state: ILandAssemblyReducerState = defaultState,
    action: ILandAssemblyAction
) {
    switch (action.type) {
        case SET_LAND_ASSEMBLY_LAYER:
            return {
                ...state,
                layerId: action.layerId,
                features: [],
                isFetchingStats: false,
                stats: null,
                error: null
            };
        case ADD_FEATURE_TO_LAND_ASSEMBLY: {
            const idx = state.features.findIndex(e => e.featureId === action.feature.featureId);
            if (idx === -1) {
                const newFeatures = [...state.features];
                newFeatures.push(action.feature);
                return {
                    ...state,
                    features: newFeatures
                };
            }
            return state;
        }
        case REMOVE_FEATURE_FROM_LAND_ASSEMBLY: {
            const idx = state.features.findIndex(e => e.featureId === action.feature.featureId);
            if (idx !== -1) {
                const newFeatures = [...state.features];
                newFeatures.splice(idx, 1);
                return {
                    ...state,
                    features: newFeatures
                };
            }
            return state;
        }
        case TOGGLE_LAND_ASSEMBLY_FEATURES: {
            const newFeatures = [...state.features];
            for (const feature of action.features) {
                const idx = newFeatures.findIndex(e => e.featureId === feature.featureId);
                if (idx === -1) {
                    newFeatures.push(feature);
                } else {
                    newFeatures.splice(idx, 1);
                }
            }
            return {
                ...state,
                features: newFeatures
            };
        }
        case SET_LAND_ASSEMBLY_FEATURES: {
            return {
                ...state,
                layerId: action.layerId,
                features: [...action.features]
            };
        }
        case FETCH_STATS_REQUEST:
            return {
                ...state,
                isFetchingStats: true,
                stats: null,
                error: null
            };
        case FETCH_STATS_SUCCESS:
            return {
                ...state,
                isFetchingStats: false,
                stats: action.stats,
                error: null
            };
        case FETCH_STATS_FAILURE:
            return {
                ...state,
                isFetchingStats: false,
                stats: null,
                error: action.error
            };
        case SET_SITE_CARD_CREATOR_OPEN:
            return {
                ...state,
                isCreatingSiteCard: action.isOpen
            };
        default:
            return state;
    }
}
